/* eslint max-len: 0 */

import object from 'common/helpers/primitives/object'
import generateAbsoluteLinks from './generateAbsoluteLinks'
import { Links } from './types'


/*

 if you need add route to autotests in CI add:

 autotest: {
  auth: Boolean,                                // if true (check route only with auth)
                                                // if false (check route only with no auth)
                                                // if undefined (check with auth and no auth)
  screenshot: Boolean,                          // match screenshots tests
  currentPath: String,                          // path for :slug, :id, etc
  redirect: Boolean                             // block redirect error in route (if you need)
 }

 you can also use array of autotests

 */

// It shouldn't have any type to create it's structure for autocomplete
const links = {
  home: { path: '' },
  homeMen: { path: 'men' },

  // home page in site, temp because of ab-test landing:mainLikeFreeTrial
  homeTemp: { path: 'main', analytics: { page: 'main' }, gender: 'female' },
  homeTempMen: { path: 'main/men', analytics: { page: 'main' }, gender: 'male' },

  // Auth

  register: { path: 'register', analytics: { page: 'register' }, autotest: { auth: false, screenshot: true } },
  login: { path: 'register/log-in', analytics: { page: 'login' }, autotest: { auth: false } }, // TODO change to /login
  remindPassword: { path: 'register/remind-password', analytics: { page: 'remind password' }, autotest: { auth: false } },
  recoverPassword: { path: 'register/recover-password', analytics: { page: 'recover password' }, autotest: { auth: false } },
  resetPassword: { path: 'register/password-reset', analytics: { page: 'rest password' } },
  logout: { path: 'logoff' },

  // SEO

  perfumes: { path: 'perfumes', analytics: { page: 'seo perfumes' } },
  colognes: { path: 'colognes', analytics: { page: 'seo colognes' } },

  // Payment

  checkout: { path: 'subscription/payment', analytics: { page: 'checkout', pageType: 'payment' }, autotest: { auth: false, redirect: true } },
  subscribe: { path: 'subscribe', analytics: { page: 'subscribe', pageType: 'payment' }, autotest: { auth: false } },
  subscribeNew: { path: 'subscribe-prototype', analytics: { page: 'subscribe', pageType: 'payment' } },
  giftRedeem: { path: 'gift/redeem', analytics: { page: 'gift redeem', pageType: 'payment' }, autotest: { disabled: true } },
  couponPayment: { path: 'subscription/payment/coupon', analytics: { page: 'coupon subscription payment', pageType: 'payment' } },
  giftCardPayment: { path: 'giftcard/payment', analytics: { page: 'gift card payment', pageType: 'payment' } },
  giftSubscriptionPayment: { path: 'gift/payment', analytics: { page: 'gift subscription payment', pageType: 'payment' } },

  // New payment flow

  queueRedeem: { path: 'queue/redeem', analytics: { page: 'payment', pageType: 'payment' } },
  tossInRedeem: { path: 'toss-in/redeem', analytics: { page: 'payment', pageType: 'payment' } },

  // Unsubscribe

  cancelSubscription: { path: 'subscription/cancel', analytics: { page: 'cancel subscription', pageType: 'cancel subscription' } },

  // Resubscribe

  resubscribeNoOffer: { path: 're-subscribe', analytics: { page: 'resubscribe no offer', pageType: 'resubscribe' } },
  resub: { path: 'resub', analytics: { page: 'resubscribe card', pageType: 'resubscribe' } },
  resubscribe: { path: 'resubscribe', analytics: { page: 'resubscribe new', pageType: 'resubscribe' } },
  resubscribe3: { path: 'resubscribe-3', analytics: { page: 'resubscribe 3 months', pageType: 'resubscribe' } },
  resubscribe5: { path: 'resubscribe-5', analytics: { page: 'resubscribe 5 months', pageType: 'resubscribe' } },
  resubscribe50: { path: 'resubscribe-50', analytics: { page: 'resubscribe 50% discount', pageType: 'resubscribe' } },
  resubscribeFree: { path: 'resubscribe-free', analytics: { page: 'resubscribe 1 month free', pageType: 'resubscribe' } },
  resubscribe5mo12: { path: 'resubscribe-5mo12', analytics: { page: 'resubscribe 5 months by $12', pageType: 'resubscribe' } },
  resubscribeFreeProduct: { path: 'resubscribe-freeperfume', analytics: { page: 'resubscribe perfume free', pageType: 'resubscribe' } },

  // Unpause

  unpause: { path: 'unpause', analytics: { page: 'unpause', pageType: 'unpause' } },
  unpause50: { path: 'unpause-50', analytics: { page: 'unpause 50', pageType: 'unpause' } },

  // Card update

  cardUpdate: { path: 'card-update', analytics: { page: 'card update', pageType: 'card update' } },
  cardUpdate50: { path: 'card-update-50', analytics: { page: 'card update 50% discount', pageType: 'card update' } },
  caseCardUpdate: { path: 'case-card-update', analytics: { page: 'case card update', pageType: 'card update' } },
  cardUpdateFreePerfume: { path: 'card-update-freeperfume', analytics: { page: 'card update free perfume', pageType: 'card update' } },

  // Gift

  gift: { path: 'gift', analytics: { page: 'gift' }, autotest: { disabled: true } },
  gifts: { path: 'gifts', analytics: { page: 'gifts', pageType: 'gifts' }, autotest: { disabled: true } },
  giftFb: { path: 'gift-fb', analytics: { page: 'gifts facebook' } },
  giftCard: { path: 'giftcard', analytics: { page: 'gift cards' }, autotest: {} },
  giftSet: { path: 'giftset', analytics: { page: 'women gift sets', pageType: 'gift sets' }, autotest: {} }, // TODO why not giftset`S` ?
  giftSetsMen: { path: 'giftset-men', analytics: { page: 'men gift sets', pageType: 'gift sets' }, autotest: {} },
  newGiftSet: { path: 'giftset/:name', analytics: { page: 'gift set' }, autotest: { currentPath: 'giftset/hollywood-diva' } },
  skincareSets: { path: 'skincare-set', analytics: { page: 'skincare sets' }, autotest: {} },
  skincareSet: { path: 'skincareset/:name', analytics: { page: 'skincare set' }, autotest: { currentPath: 'skincareset/ultimate-skin-collection' } },

  // Products

  newProducts: { path: 'new', analytics: { page: 'new products', pageType: 'products' }, autotest: {} },
  scentbirdProducts: { path: 'scentbird-products', analytics: { page: 'scentbird products' } },
  scentbirdProductsNew: { path: 'brand/scentbird', analytics: { page: 'scentbird products' } },
  howHandCreamsWork: { path: 'hand-creams/how-it-works', analytics: { page: 'hand creams how it works' }, autotest: {} },
  skincare: { path: 'skincare', analytics: { page: 'skincare products' } },
  wellness: { path: 'wellness', analytics: { page: 'wellness products' } },

  // !isNewSkincareEnabled
  goldCollectionMen: { path: 'collections-men/gold-collection', analytics: { page: 'skincare gold collection products' } },
  goldCollectionWomen: { path: 'collections-women/gold-collection', analytics: { page: 'skincare gold collection products' } },
  handCreams: { path: 'hand-creams', analytics: { page: 'hand cream products' } }, // TODO deprecated
  bodyLip: { path: 'body-lip', analytics: { page: 'body lip products' } }, // TODO deprecated

  personalCare: { path: 'personal-care', analytics: { page: 'personal care products' } },

  makeup: { path: 'makeup', analytics: { page: 'makeup products' }, autotest: {} },
  makeupBrand: { path: 'makeup/brand/:brandName', analytics: { page: 'makeup brand' } },

  candles: { path: 'candles', analytics: { page: 'candle products' } },
  bestsellersMen: { path: 'bestsellers-men', analytics: { page: 'men bestsellers', pageType: 'bestsellers' } },
  bestsellersWomen: { path: 'bestsellers-women', analytics: { page: 'women bestsellers', pageType: 'bestsellers' } },
  collection: { path: 'collection/:name', analytics: { page: 'collections', pageType: 'collections' } },
  collectionMen: { path: 'collections-men/:name', analytics: { page: 'men collections', pageType: 'collections' } },
  collectionWomen: { path: 'collections-women/:name', analytics: { page: 'women collections', pageType: 'collections' } },
  skincareCollectionItemMenNew: { path: 'skincare-men/collections/:name', analytics: { page: 'men collections', pageType: 'collections' } },
  skincareCollectionItemWomenNew: { path: 'skincare/collections/:name', analytics: { page: 'women collections', pageType: 'collections' } },
  skincareCollectionWomen: { path: 'skincare-collections-women', analytics: { page: 'skincare collections women', pageType: 'collections' } },
  skincareCollectionMen: { path: 'skincare-collections-men', analytics: { page: 'skincare collections men', pageType: 'collections' } },
  skincareCollectionWomenNew: { path: 'skincare/collections', analytics: { page: 'skincare collections women', pageType: 'collections' } },
  skincareCollectionMenNew: { path: 'skincare-men/collections', analytics: { page: 'skincare collections men', pageType: 'collections' } },
  bambooCharcoalCollection: { path: 'collections-men/bamboo-charcoal', analytics: { page: 'bamboo charcoal collection products', pageType: 'collections' } },
  productTypeCollectionMen: { path: ':slug-collections-men', analytics: { page: 'men collections', pageType: 'collections' } },
  productTypeCollectionWomen: { path: ':slug-collections-women', analytics: { page: 'women collections', pageType: 'collections' } },
  productTypeCollectionMenNew: { path: ':slug-men/collections', analytics: { page: 'men collections', pageType: 'collections' } },
  productTypeCollectionWomenNew: { path: ':slug/collections', analytics: { page: 'women collections', pageType: 'collections' } },
  collectionLanding: { path: 'collections/:slug', analytics: { page: 'collection landing', pageType: 'collections' } },
  flashSale: { path: 'flash-sale', analytics: { page: 'flash sale' } },
  fathersDayGiftSet: { path: 'bamboo-charcoal', analytics: { page: 'bamboo charcoal gift set' } },

  // Product

  productPageCommonProduct: { path: 'product/:slug', analytics: { page: 'product', pageType: 'product' }, autotest: { currentPath: 'product/505' } },
  productPagePerfumes: { path: 'perfumes/:slug', analytics: { page: 'perfume product', pageType: 'product' } },
  productPagePerfume: { path: 'perfume/:slug', analytics: { page: 'perfume product', pageType: 'product' }, autotest: { screenshot: true, currentPath: 'perfume/robert-graham-fortitude-1103' } },
  productPageHandCreams: { path: 'hand-creams/:slug', analytics: { page: 'hand cream product', pageType: 'product' } },
  productPageHandCream: { path: 'hand-cream/:slug', analytics: { page: 'hand cream product', pageType: 'product' } },
  productPageBody: { path: 'body/:slug', analytics: { page: 'body product', pageType: 'product' } },
  productPageBodyLip: { path: 'body-lip/:slug', analytics: { page: 'body lip product', pageType: 'product' } },
  productPageShowerGels: { path: 'shower-gels/:slug', analytics: { page: 'shower gel product', pageType: 'product' } },
  productPageShowerGel: { path: 'shower-gel/:slug', analytics: { page: 'shower gel product', pageType: 'product' } },
  productPageCandles: { path: 'candles/:slug', analytics: { page: 'candle product', pageType: 'product' } },
  productPageCandle: { path: 'candle/:slug', analytics: { page: 'candle product', pageType: 'product' } },
  productExtra: { path: 'extra/:slug', analytics: { page: 'extra product', pageType: 'product' } },
  productExtras: { path: 'extras/:slug', analytics: { page: 'extra product', pageType: 'product' } },
  productLanding: { path: 'perfume-landing/:slug', analytics: { page: 'perfume landing product', pageType: 'product' } },
  productMakeup: { path: 'makeup(.*)/:slug', analytics: { page: 'makeup product', pageType: 'product' } },
  productSkincare: { path: 'skincare(.*)/:slug', analytics: { page: 'skincare product', pageType: 'product' } },
  productWellness: { path: 'wellness(.*)/:slug', analytics: { page: 'wellness product', pageType: 'product' } },
  productPersonalCare: { path: 'personal-care/(.*)/:slug', analytics: { page: 'personal care product', pageType: 'product' } },

  // Common

  faq: { path: 'faq', analytics: { page: 'faq' } },
  pick: { path: 'pick', analytics: { page: 'pick' }, autotest: { auth: false } }, // TODO add 'screenshot' to autotest when there will be static products feed
  plan: { path: 'plan', analytics: { page: 'plan' } },
  team: { path: 'team', analytics: { page: 'team' }, autotest: {} },
  blog: { path: 'blog', analytics: { page: 'blog' } },
  ccpa: { path: 'ccpa', analytics: { page: 'CCPA' } },
  queue: { path: 'queue', analytics: { page: 'queue' } },
  terms: { path: 'terms', analytics: { page: 'terms and conditions' } },
  press: { path: 'press', analytics: { page: 'press' } },
  choose: { path: 'choose', analytics: { page: 'choose' } },
  tossIn: { path: 'toss-in', analytics: { page: 'toss in' } },
  invite: { path: 'invite', analytics: { page: 'invite', pageType: 'invite' }, screenshot: true },
  fInvite: { path: 'f/invite', analytics: { page: 'women invite', pageType: 'invite' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544046136165500
  mInvite: { path: 'm/invite', analytics: { page: 'men invite', pageType: 'invite' } }, // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544046136165500
  contact: { path: 'contact', analytics: { page: 'contact' } },
  blogger: { path: 'blogger', analytics: { page: 'blogger' } },
  privacy: { path: 'privacy', analytics: { page: 'privacy policy' } },
  request: { path: 'request', analytics: { page: 'request perfume' } },
  coupons: { path: 'coupons', analytics: { page: 'coupons' }, autotest: {} },
  welcome: { path: 'welcome', analytics: { page: 'welcome' } },
  careers: { path: 'careers', analytics: { page: 'careers' }, autotest: {} },
  buyQueue: { path: 'buy-queue', analytics: { page: 'buy queue' } },
  thankYou: { path: 'thankyou', analytics: { page: 'thankyou' } },
  recurlyThankYou: { path: 'thankyou/:purchaseSessionId', analytics: { page: 'thankyou' } },
  men25Off: { path: 'men/25-off', analytics: { page: '25-off' } },
  tracking: { path: 'tracking', analytics: { page: 'tracking' }, autotest: { auth: true, screenshot: true } },
  casePrize: { path: 'case-prize', analytics: { page: 'case prize' } },
  downgrade: { path: 'downgrade', analytics: { page: 'downgrade' } },
  howItWorks: { path: 'how-it-works', analytics: { page: 'how it works' }, autotest: {} },
  unsubscribe: { path: 'unsubscribe', analytics: { page: 'unsubscribe' }, autotest: { auth: true } },
  searchResult: { path: 'search-result', analytics: { page: 'search result' } },
  payPalUpdate: { path: 'paypal-update', analytics: { page: 'update to paypal' } },
  giftCardTerms: { path: 'giftcards-terms', analytics: { page: 'gift cards terms' } },
  claimGiftCard: { path: 'claim', analytics: { page: 'claim gift card' }, autotest: {} },
  improveSurvey: { path: 'improve-survey', analytics: { page: 'customer survey' }, autotest: { auth: true } },
  improveRecommendations: { path: 'improve-recommendations', analytics: { page: 'improve recommendations' } /* , autotest: { auth: true } */ },
  fragranceFinder: { path: 'fragrance-finder', analytics: { page: 'fragrance finder' } },
  popularInStates: { path: 'popular-in-states', analytics: { page: 'popular in states' }, autotest: {} },
  scentbirdReviews: { path: 'scentbird-reviews', analytics: { page: 'scentbird reviews' }, autotest: {} },
  affiliateProgram: { path: 'affiliate-program', analytics: { page: 'affiliate program' } },
  facebookEmailRegistration:  { path: 'facebook-email', analytics: { page: 'register facebook email' } },
  freeScentbirdPefumeSocial:  { path: 'free-scentbird-perfume-social', analytics: { page: 'free scentbird perfume' } },
  successfulEmailVerification: { path: 'opted-in', analytics: { page: 'successful email verification' } },
  caseSubscription: { path: 'case-subscription', analytics: { page: 'case subscription' } },

  // Upgrade Subscription Plan

  upgrade: { path: 'upgrade', analytics: { page: 'upgrade' } },
  upgradeProduct: { path: 'upgrade-product', analytics: { page: 'upgrade product' } },

  // Landings in site app

  mix: { path: 'mix-intro', analytics: { page: 'mix' } },
  newMix: { path: 'mix-new', analytics: { page: 'mix' } },
  newMixMale: { path: 'men/mix-new', analytics: { page: 'mix' } },
  popupShop: { path: 'popupshop', analytics: { page: 'popup shop' } },
  email: { path: 'email/:landingPage+', analytics: { page: 'email landing' }, gender: 'female' },
  emailMen: { path: 'email/men/:landingPage+', analytics: { page: 'email landing' }, gender: 'male' },
  emailQuizPick: { path: 'pick/email/:landingPage+', analytics: { page: 'email landing' } },
  freeTrial: { path: 'freetrial', analytics: { page: 'free trial' }, gender: 'female' },
  freeTrialMale: { path: 'men/freetrial', analytics: { page: 'free trial' }, gender: 'male' },
  skincareIntro: { path: 'skincare-intro', analytics: { page: 'skincare intro' } },
  referralLandingTemp: { path: 'referral/:channelCode/:personalCode', analytics: { page: 'referral landing' } }, // TODO remove after fix in router SB-2220 - added on 21.07.2020 by sonatskiy
  referralLanding: { path: 'r/:channelCode/:personalCode', analytics: { page: 'referral landing' } },

  // Horoscope

  horoscope: { path: 'horoscope', analytics: { page: 'horoscopes' }, autotest: {} },
  zodiacSign: { path: 'horoscope/:name', analytics: { page: 'horoscope' }, autotest: { currentPath: 'horoscope/leo' } },

  // Quiz

  quiz: { path: 'onboarding', analytics: { page: 'women onboarding', pageType: 'onboarding' }, autotest: { redirect: true } },
  quizMen: { path: 'onboarding-men', analytics: { page: 'men onboarding', pageType: 'onboarding' } },
  quizProduct: { path: 'onboarding-product', analytics: { page: 'onboarding product' } },

  // Profile

  profile: {
    root: { path: 'profile', analytics: { page: 'profile', pageType: 'profile' } },
    subscriptionStatus: { path: 'subscription-status', analytics: { page: 'profile subscription status' } },
    orderHistory: { path: 'order-history', analytics: { page: 'profile orders history' } },
    ecommerceOrder: { path: 'order-history/:orderId', analytics: { page: 'profile ecommerce order' } },
    changePassword: { path: 'password', analytics: { page: 'profile change password' }, autotest: { auth: true } },
    personal: { path: 'personal', analytics: { page: 'profile personal info' }, autotest: { auth: true } },
    billingAndShipping: { path: 'billing-and-shipping', analytics: { page: 'profile billing and shipping' }, autotest: { auth: true } },
    reviews: { path: 'reviews', analytics: { page: 'profile reviews' } },
    ratedProducts: { path: 'rated-products', analytics: { page: 'profile rated products' } },
    sentGifts: { path: 'sent-gifts', analytics: { page: 'profile sent gifts' } },
    // TODO check analytic and removed old links after 1 month and removed Redirects from routes - added on 15.04.2020 by @vet
    upgradeSubscription: { path: 'upgrade', analytics: { page: 'profile upgrade subscription' } },
    orders: { path: 'orders', analytics: { page: 'profile orders' } },
    order: { path: 'order/:orderId', analytics: { page: 'profile order' } },
    ordersStatus: { path: 'orders-status', analytics: { page: 'profile orders status' } },
  },

  // Other user profile

  userProfile: {
    root: { path: 'p/:userId', analytics: { page: 'other user profile', pageType: 'other user profile' } },
    receivedProducts: { path: 'received-products', analytics: { page: 'other user profile received products' } },
    productsInQueue: { path: 'products-in-queue', analytics: { page: 'other user profile queue' } },
    ratedProducts: { path: 'rated-products', analytics: { page: 'other user profile rated products' } },
    reviews: { path: 'reviews', analytics: { page: 'other user profile reviews' } },
  },

  subscription: {
    root: { path: 'subscription' },

    // Smartsearch

    smartSearch: { path: 'smartsearch', analytics: { page: 'smartsearch all', pageType: 'smartsearch' } },
    retailValue150: { path: '150', analytics: { page: 'smartsearch $150$', pageType: 'smartsearch' } },
    bestsellers: { path: 'bestsellers', analytics: { page: 'smartsearch bestsellers', pageType: 'smartsearch' } },
    bestsellersAll: { path: 'bestsellers-all', analytics: { page: 'smartsearch all bestsellers', pageType: 'smartsearch' } }, // link from emails // TODO looks weird - https://scentbird.slack.com/archives/C3CB4J1MW/p1544003052109700
    newArrivals: { path: 'newarrivals', analytics: { page: 'smartsearch newarrivals', pageType: 'smartsearch' } },
    featured: { path: 'featured', analytics: { page: 'smartsearch featured', pageType: 'smartsearch' } },
    perfumes: { path: 'perfumes', analytics: { page: 'smartsearch perfumes', pageType: 'smartsearch' }, autotest: { auth: true } },
    colognes: { path: 'colognes', analytics: { page: 'smartsearch colognes', pageType: 'smartsearch' }, autotest: { auth: true, screenshot: true } },

    // Main

    mainMen: { path: 'main-men', analytics: { page: 'men main', pageType: 'main' }, autotest: { auth: true }, gender: 'male' },
    mainWomen: { path: 'main-women', analytics: { page: 'women main', pageType: 'main' }, autotest: { auth: true }, gender: 'female' },

    // Other subscription

    extras: { path: 'extras', analytics: { page: 'extra products' }, autotest: { auth: true } },
    collectionsMen: { path: 'collections-men', analytics: { page: 'men collections', pageType: 'collections' }, autotest: { auth: true } },
    collectionsWomen: { path: 'collections-women', analytics: { page: 'women collections', pageType: 'collections' }, autotest: { auth: true } },
    recommendations: { path: 'recommendations', analytics: { page: 'recommendations' } },
    cologneOfTheMonth: { path: 'cologne-of-the-month/:year/:month', analytics: { page: 'men pom', pageType: 'pom' }, autotest: { currentPath: 'cologne-of-the-month/2018/08' } },
    perfumeOfTheMonth: { path: 'perfume-of-the-month/:year/:month', analytics: { page: 'women pom', pageType: 'pom' }, autotest: { currentPath: 'perfume-of-the-month/2018/08' } },
    currCologneOfTheMonth: { path: 'cologne-of-the-month', analytics: { page: 'men pom', pageType: 'pom' } },
    currPerfumeOfTheMonth: { path: 'perfume-of-the-month', analytics: { page: 'women pom', pageType: 'pom' } },
    cologneOfTheMonthList: { path: 'cologne-of-the-month/all', analytics: { page: 'men pom list', pageType: 'pom list' } },
    perfumeOfTheMonthList: { path: 'perfume-of-the-month/all', analytics: { page: 'women pom list', pageType: 'pom list' } },
  },

  // Brands page

  brand: { path: 'brand/:slug', analytics: { page: 'brand' }, autotest: { auth: false, currentPath: 'brand/gucci', redirect: true } },
  brands: { path: 'brands', analytics: { page: 'brands' }, autotest: { auth: false } },

  // Info

  info: {
    root: { path: 'info' },
    howTo: { path: 'howto', analytics: { page: 'how to' } },
    subscribeFor1445: { path: '1445', analytics: { page: '1445', pageType: 'women 1445' } },
    recommendations: { path: 'recommendations', analytics: { page: 'recommendations info' } },
    aboutScentbird: { path: 'about_scentbird', analytics: { page: 'about scentbird' } },
  },

  // Men info

  menInfo: {
    root: { path: 'men/info' },
    subscribeFor1445: { path: '1445', analytics: { page: '1445', pageType: 'men 1445' } },
  },

  // Affiliate

  affiliate: {
    root: { path: 'affiliate' },
    faq: { path: 'faq', analytics: { page: 'affiliate faq' } },
    request: { path: 'request', analytics: { page: 'affiliate request' } },
    strategies: { path: 'strategies', analytics: { page: 'affiliate strategies' } },
    promoResources: { path: 'promo-resources', analytics: { page: 'affiliate promo resources' } },
    starterPackage: { path: 'starter-package', analytics: { page: 'affiliate starter package' } },
  },

  // Recommendations
  netflixRecommendations: { path: 'favorite-perfumes-search', analytics: { page: 'NFLX recommendations' } },

  recommendations: {
    root: { path: 'recommendations', analytics: { page: 'recommendations' } },
    history: { path: 'history', analytics: { page: 'recommendations history' } },
    quiz: { path: 'quiz', analytics: { page: 'recommendations quiz' } },
    selections: { path: 'selections', analytics: { page: 'recommendations selections' } },
  },

  // Incubator
  incubator: {
    root: { path: 'incubator' },
    neonHeat: { path: 'neon-heat', analytics: { page: 'incubator neon heat' } },
    fragranceConcepts: { path: 'fragrance-concepts', analytics: { page: 'incubator fragrance concepts' } },
    fragranticaSelections: {
      root: { path: 'fragrantica-selections' },
      vote: { path: 'vote' },
    },
  },

  // Membership
  membership: { path: 'membership', analytics: { page: 'membership' } },

  // Notes
  noteWomen: { path: 'notes/:slug/women', analytics: { page: 'note women' } },
  noteMen: { path: 'notes/:slug/men', analytics: { page: 'note men' } },

  // Collections for sale
  collectionsForSale: { path: 'collections-for-sale', analytics: { page: 'collections for sale' } },
  collectionForSale: { path: 'collections-for-sale/:slug', analytics: { page: 'collection for sale' } },

  // TasteMaker
  tasteMakers: { path: 'tastemakers', analytics: { page: 'tastemakers' } },
  tasteMakersMen: { path: 'tastemakers-men', analytics: { page: 'tastemakers men' } },

  // Get the most
  getTheMost: { path: 'get-the-most', analytics: { page: 'get the most' } },

  // Mobile app web view
  siteApi: {
    root: { path: 'site-api' },
    teamPage: { path: 'team-page-html' },
  },
}

const absoluteLinks = generateAbsoluteLinks(links)

absoluteLinks.fromBackend = {}

if (typeof window !== 'undefined') {
  const linksFromBackend = object.get(window, '__globals__.linksFromBackend', {})
  const linksFromBackendKeys = Object.keys(linksFromBackend)

  if (linksFromBackendKeys.length) {
    (links as Links).fromBackend = linksFromBackend
    absoluteLinks.fromBackend = linksFromBackendKeys.reduce((result, key) => {
      result[key] = linksFromBackend[key].path

      return result
    }, {})
  }
}


export default absoluteLinks

export {
  links,
}
